import { ReactNode, useEffect, useState } from 'react';
import CommonHeader from '../feature/CommonHeader';
import CommonFooter from '../feature/CommonFooter';
import Breadcrumb from '../feature/Breadcrumb';
import FAQSection from '../feature/FAQSection';

interface PageLayoutProps {
  children: ReactNode;
  showBreadcrumb?: boolean;
  breadcrumbItems?: Array<{ name: string; href?: string }>;
  className?: string;
  /** ヒーロー(ビルボード)。指定するとヒーローの直後にパンくずを描画する */
  hero?: ReactNode;
}

export default function PageLayout({
  children,
  showBreadcrumb = true,
  breadcrumbItems,
  className = '',
  hero
}: PageLayoutProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className={`min-h-screen bg-white transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'} ${className}`}>
      <CommonHeader />

      {hero && <div className="pt-[132px]">{hero}</div>}

      {showBreadcrumb && (
        <div className={hero ? '' : 'pt-[132px]'}>
          <Breadcrumb items={breadcrumbItems} />
        </div>
      )}

      <main className={showBreadcrumb || hero ? '' : 'pt-[132px]'}>
        {children}
      </main>

      <FAQSection />
      <CommonFooter />
    </div>
  );
}
